<script>
    import { emitter } from "../stores.js";
    import { onMount } from "svelte";

    export let listdata;

    onMount(async () => {
        for(let i = 0; i < listdata.length; i++){
            if(listdata[i].s === true && listdata[i].cbf !== undefined) listdata[i].cbf();            
        }
    });
    
    function select(idx) {
        // console.log("doing select")
        for(let i = 0; i < listdata.length; i++){
            listdata[i].s = false;
            if(i === idx){
                listdata[i].s = true;
                if(listdata[i].cbf !== undefined){
                    listdata[i].cbf();
                }
            } 
        }
        $emitter.emit('progressClick', '');
        // console.log(chipsdata);
    }

</script>

<div class="maincontainer">

    {#each listdata as litem, index}
    <div on:click={()=>{select(index);}} class="raise {(litem.s) ? "selected" : ""} listitem ">
        <div class="listitemtexcontainer">{litem.t}</div>
    </div>
        
    {/each}
    
</div>

<style>
.maincontainer {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
}
.listitem {
    margin-top: 20px;
    border-radius: 3px;
    width: 100%;
    max-width: 350px;
    color: #2c313d;
    border: solid 1px;
    border-color: #2c313d;
    text-align: center;
    padding: 20px;
    cursor: pointer;
}
/* .selected {
    background-color: black;
    color: white;
} */
.listitem:hover {
    background-color: #2c313d;
    color: white;
    /* border-color: white; */
}

@media (max-device-width: 1024px), (max-width: 1023px) {
    .listitem {
        width: 100%;
        max-width: 280px;
        box-sizing: border-box;
    }

}
</style>